import { Box, Typography, Paper } from "@mui/material";
import React from "react";
import HeaderIcons from "../../Images/headericon.png";
import TransactionsTable from "../Tables/TransactionsTable";

function Index() {
  return (
    <Box sx={{
      width: '100%',
      // minHeight: '90vh',
      // padding: '10px',
    }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography sx={{
          color: '#1f2937',
          fontSize: '28px',
          fontWeight: 700,
          marginBottom: '8px'
        }}>
          Transaction Management
        </Typography>
        <Typography sx={{
          color: '#6b7280',
          fontSize: '16px'
        }}>
          View and manage all transaction records with comprehensive details
        </Typography>
      </Box>

      {/* Main Content Card */}
      <Paper sx={{
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        border: '1px solid #e5e7eb',
        overflow: 'hidden'
      }}>
        <TransactionsTable />
      </Paper>
    </Box>
  );
}

export default Index;